// extracted by css-extract-rspack-plugin
export default {"row":"FooterRow_row__istNQ"};